/**
 * Centralized view key constants for User Profile Config.
 * Each frontend view/screen that uses persistent user configuration
 * should have a unique key defined here.
 */
export const USER_PROFILE_CONFIG_VIEW_KEYS = {
    PRODUCTS_TABLE: "PRODUCTS_TABLE",
    PACKAGE_ORDER_TABLE: "PACKAGE_ORDER_TABLE"
};
